import React from 'react';
import {Badge} from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import {useNotifications} from '../../hooks/useNotifications';

const getBadgeTone = (type) => {
  const code = Number(type);
  if (Number.isNaN(code)) {
    return 'secondary';
  }
  const category = Math.floor(code / 100);
  switch (category) {
    case 1:
      return 'info';
    case 2:
      return 'success';
    case 3:
    case 4:
      return 'warning';
    case 5:
      return 'danger';
    default:
      return 'secondary';
  }
};

const Notifications = ({eid}) => {
  const {notifications} = useNotifications(eid);

  return (
    <div className="island p-0 overflow-hidden h-100 d-flex flex-column">
      <div style={{maxHeight: 4 * 72, overflowY: 'auto'}}>
        {notifications.length === 0 ? (
          <p className="small text-center py-3 mb-0" style={{color: 'var(--text-secondary)'}}>No notifications recorded yet.</p>
        ) : (
          notifications.map((item, idx) => {
            const timestamp = item.timestamp?.toDate ? item.timestamp.toDate() : item.timestamp;
            const badgeTone = getBadgeTone(item.type);

            return (
              <div
                key={item.id || idx}
                className="px-3 py-2"
                style={{borderBottom: idx === notifications.length - 1 ? 'none' : '1px solid var(--border-color)'}}
              >
                <div className="d-flex align-items-start justify-content-between gap-2">
                  <div>
                    <div className="d-flex align-items-center gap-2">
                      <Badge bg={badgeTone} className="px-2 py-1">
                        {item.type || 'notification'}
                      </Badge>
                      {item.shortDescription && (
                        <span className="small" style={{color: 'var(--text-primary)'}}>{item.shortDescription}</span>
                      )}
                    </div>
                    {item.longDescription && (
                      <div className="small mt-1" style={{color: 'var(--text-secondary)'}}>{item.longDescription}</div>
                    )}
                  </div>
                  <span className="small" style={{color: 'var(--text-secondary)', whiteSpace: 'nowrap', marginLeft: 12}}>
                    {timestamp ? moment(timestamp).format('DD.MM.YYYY HH:mm') : '-'}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

Notifications.propTypes = {
  eid: PropTypes.string.isRequired,
};

export default Notifications;
